import React, { useCallback, useState } from "react";

type Props = {
  title: string;
  index: number;
  active: number;
  setSelectedTab: (index: number) => void;
};

const TabTitle = ({ title, setSelectedTab, index, active }: Props) => {
  const [isActive, setIsActive] = useState(true);
  const onClick = useCallback(() => {
    setSelectedTab(index);
  }, [setSelectedTab, index]);

  // const activeTab = index;
  const activeClass = isActive ? "is-active" : "";
  return (
    <li>
      <button type="button" onClick={onClick}>
        {title}
      </button>
    </li>
  );
};

export default TabTitle;
